import { GetCompanyStatus } from "./utilsCompanyStatus";

export const ConnectorStatus = {
  unknown: { Name: "Offline", Description: "Connector is offline." },
  shutdown: { Name: "Shutdown", Description: "Connector is shutdown." },
  "shutting-down": { Name: "Shutdown", Description: "Connector is shutdown." },
  alive: { Name: "Alive", Description: "Connector is online." },
  uninstalled: {
    Name: "Uninstalled",
    Description: "Connector has been uninstalled",
  },
};

export type ConnectionStatusType = keyof typeof ConnectorStatus;

export function GetConnectorStatus(key: ConnectionStatusType) {
  const found = ConnectorStatus[key];

  if (!found) {
    return { Name: "-" };
  }

  return found;
}

export const showConnectionStatus = (status: ConnectionStatusType | "") => {
  switch (status) {
    case "unknown":
      return GetCompanyStatus("Offline");

    case "uninstalled":
      return GetCompanyStatus("Uninstalled");

    case "shutdown":
      return GetCompanyStatus("Shutdown");

    case "shutting-down":
      return GetCompanyStatus("Shutting-Down");
  }
};

export const ConnectorHosts = {
  Local: {
    Name: "Local",
    Color: "#1371ce",
    Description: "This company's installation is installed locally",
  },
  RightNetworks: {
    Name: "Right Networks",
    Color: "#33b659",
    Description: "This company's installation is hosted on Right Networks",
  },
  WebConnector: {
    Name: "Web Connector",
    Color: "#ce8d13",
    Description: "This company is using Intuit's Web Connector",
  },
};

export type ConnectorHost = keyof typeof ConnectorHosts;

export function GetConnectorHost(type: ConnectorHost) {
  return ConnectorHosts[type];
}
